import { Controller } from "@hotwired/stimulus"

// Opens/closes the cart modal (a native <dialog>). Attached to <body> so the nav cart icon
// (inside the turbo-permanent nav) and the dialog can share one controller.
export default class extends Controller {
  static targets = ["dialog", "panel"]

  open(event) {
    if (!this.hasDialogTarget) return // no dialog on this page → let the link go to /cart
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  // Close when clicking the backdrop / outside the panel (Escape is handled natively).
  backdropClose(event) {
    if (this.hasPanelTarget && !this.panelTarget.contains(event.target)) {
      this.dialogTarget.close()
    }
  }
}
